import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Box, Button, IconButton } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import FeedbackIcon from "@mui/icons-material/Feedback";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../../i18n";
import { useIntl } from "react-intl";
import { useAuth } from "../../providers/AuthProvider";
import FeedbackDialog from "../common/FeedbackDialog";

export default function AppHeader({ onMenuToggle }) {
  const { locale, setLocale } = useI18n();
  const intl = useIntl();
  const navigate = useNavigate();
  const { company, member, logout } = useAuth();
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  const memberName = (() => {
    if (member?.fullName) return member.fullName;
    const first = member?.firstName || "";
    const last = member?.lastName || "";
    if (!first && !last) return "";
    return locale === "ja"
      ? `${last} ${first}`.trim()
      : `${first} ${last}`.trim();
  })();

  const toggleLang = () => {
    setLocale(locale === "ja" ? "en" : "ja");
  };

  const handleLogout = () => {
    logout();
    navigate("/signin", { replace: true });
  };

  return (
    <AppBar position="fixed" elevation={1} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ height: "64px", display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuToggle}
            sx={{ display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ fontWeight: 700, whiteSpace: "nowrap" }}>
            {intl.formatMessage({ id: "app.title" })}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.5, md: 2 } }}>
          {(company?.companyName || memberName) && (
            <Typography
              variant="body2"
              sx={{
                color: "inherit",
                opacity: 0.85,
                display: { xs: "none", sm: "block" },
                maxWidth: { sm: 200, md: 320 },
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {[company?.companyName, memberName].filter(Boolean).join(" · ")}
            </Typography>
          )}
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 0.5, cursor: "pointer" }}
            onClick={toggleLang}
          >
            <LanguageIcon fontSize="small" />
            <Typography sx={{ fontWeight: 600, fontSize: "0.875rem", whiteSpace: "nowrap" }}>
              {locale === "ja" ? "JA / EN" : "EN / JA"}
            </Typography>
          </Box>
          <IconButton
            color="inherit"
            onClick={() => setFeedbackOpen(true)}
            title="改善要望"
          >
            <FeedbackIcon />
          </IconButton>
          <Button
            color="inherit"
            size="small"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
          >
            <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
              {intl.formatMessage({ id: "app.logout" })}
            </Box>
          </Button>
        </Box>
      </Toolbar>
      <FeedbackDialog
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
        appName="myCompany-member"
      />
    </AppBar>
  );
}
